import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type AiCostLimitUsersFetchFailedAction = {
	type: 'AI_COST_LIMIT_USERS_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): AiCostLimitUsersFetchFailedAction => ({
	type: 'AI_COST_LIMIT_USERS_FETCH_FAILED',
	payload,
});
